import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { excludedWidgetsUrls } from '@models/widget.model';
import { AbilityService } from 'ability';
import * as moment from 'moment';
import { BehaviorSubject, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private router = inject(Router);
  private http = inject(HttpClient);
  private ability = inject(AbilityService);

  public forceOpenWidget = new BehaviorSubject<{ force: boolean; collapsed: boolean }>({ force: false, collapsed: false });
  public isWidgetShown = new BehaviorSubject(false);

  openWidget(collapsed = false): void {
    this.forceOpenWidget.next({ force: true, collapsed });
  }

  canShowWidgetByCurrentUrl(): boolean {
    return !excludedWidgetsUrls.some((url) => this.router.url.includes(url));
  }

  canShowWidgetByPermissions(): boolean {
    return this.ability.can('read', 'HelpMarketing') && this.ability.cannot('read', 'HideFeedback');
  }

  canShowWidget(): Observable<boolean> {
    if (!this.canShowWidgetByPermissions() || !this.canShowWidgetByCurrentUrl()) {
      return of(false);
    }

    return this.http
      .get<{
        showNpsWidget: boolean;
        remindMeDate: string;
      }>('api/nps/date', { headers: { 'x-front-queue': 'true' } })
      .pipe(
        map((data) => {
          if (data.showNpsWidget) {
            return true;
          }

          const remindMeDate = moment.utc(data.remindMeDate);
          const now = moment.utc();

          return remindMeDate.isBefore(now);
        })
      );
  }

  remindMeLater(period: 3 | 30): Observable<unknown> {
    return this.http.post<unknown>(
      'api/nps/remind-later',
      { days: period },
      { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
    );
  }

  send(rating: number, description: string): Observable<unknown> {
    return this.http.post<unknown>(
      'api/nps/send',
      { rating, message: description, sendEmail: true },
      { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
    );
  }
}
